import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseHttpService } from './base-http.service';

export interface CallejeroAddress {
	house_number?: string;
	road?: string;
	city_district?: string;
	country?: string;
	country_code?: string;
}

export interface CallejeroResult {
	place_id: number;
	display_name: string;
	lat: string;
	lon: string;
	osm_type?: string;
	osm_id?: number;
	type?: string;
	address?: CallejeroAddress;
}

@Injectable({ providedIn: 'root' })
export class CallejeroService extends BaseHttpService {
	private baseUrl = environment.callejeroUrl;

	search(query: string): Observable<CallejeroResult[]> {
		const params = new HttpParams().set('q', query).set('addressdetails', '1');
		return this.http
			.get<CallejeroResult[]>(`${this.baseUrl}`, { params })
			.pipe(catchError(() => of([])));
	}
}
